export const logger = {
  error: (context: string, error: unknown) => {
    console.error(`[${context}]:`, error);
  },
  warn: (context: string, message: string) => {
    console.warn(`[${context}]:`, message);
  },
  info: (context: string, message: string) => {
    console.info(`[${context}]:`, message);
  },
  // Можно расширить для production (Sentry, etc)
};
